import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children }) => <span className="section-tag">{children}</span>;

const MARQUEE_ITEMS = ["POP / POS Displays", "Grand-Format Printing", "Backlit Displays", "Retail Environments", "Window Graphics", "Custom Fabrication", "Professional Installation", "Design & Engineering"];

export const Marquee = () => (
  <div className="marquee py-5" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[0, 1].map((rep) => (
        <div key={rep} className="flex shrink-0">
          {MARQUEE_ITEMS.map((item, i) => (
            <span key={`${rep}-${i}`} className="flex items-center font-display font-extrabold uppercase tracking-wide text-xl px-6" style={{ color: "var(--text-3)" }}>
              {item}
              <span className="ml-12 w-2.5 h-2.5 inline-block" style={{ background: ["var(--brand-orange)", "var(--brand-magenta)", "var(--brand-cyan)", "var(--brand-lime)"][i % 4] }} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const PageHeader = ({ tag, title, subtitle }) => (
  <section className="pt-40 pb-16" style={{ background: "var(--bg)" }}>
    <div className="msg-container">
      <Reveal>
        <SectionTag>{tag}</SectionTag>
        <h1 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl mt-6 max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-base md:text-lg mt-6 max-w-2xl leading-relaxed" style={{ color: "var(--text-2)" }}>
            {subtitle}
          </p>
        )}
      </Reveal>
    </div>
  </section>
);

export const QuoteCTA = () => (
  <section className="py-24 relative overflow-hidden" style={{ background: "var(--bg-2)" }} data-testid="quote-cta-banner">
    <div className="absolute top-0 left-0 w-full h-1 flex">
      <div className="flex-1" style={{ background: "var(--brand-orange)" }} />
      <div className="flex-1" style={{ background: "var(--brand-magenta)" }} />
      <div className="flex-1" style={{ background: "var(--brand-cyan)" }} />
      <div className="flex-1" style={{ background: "var(--brand-lime)" }} />
    </div>
    <div className="msg-container flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
      <Reveal>
        <SectionTag>Start Your Project</SectionTag>
        <h2 className="font-display font-black uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl mt-5 max-w-xl leading-tight">
          Have a sign, display, or rollout in mind?
        </h2>
        <p className="mt-4 text-base md:text-lg max-w-lg" style={{ color: "var(--text-2)" }}>
          Tell us your specs — we'll respond with pricing, timelines, and material recommendations within one business day.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <Link to="/quote" className="btn-brand text-nowrap" data-testid="cta-request-quote-btn">
          Request a Quote <ArrowRight size={16} />
        </Link>
      </Reveal>
    </div>
  </section>
);
